import React from "react";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

const TRUST = [
  "Fakturace firmám",
  "Individuální plán úklidu",
  "Brno a okolí",
  "Rychlá komunikace",
];

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#111111] text-white py-14 md:py-16"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 items-start">
          <div>
            <Link to="/" aria-label="SANVIORO – domů">
              <img
                src="/sanvioro-logo-wordmark-white.png"
                alt="SANVIORO"
                className="h-12 md:h-14 w-auto"
                data-testid="footer-logo"
              />
            </Link>
            <p className="mt-6 text-white/85 text-[15px] max-w-sm leading-relaxed">
              Pravidelný úklid kanceláří, firemních prostor a provozoven
              v Brně. Spolehlivý partner pro firmy, SVJ a správu objektů.
            </p>

            <ul
              data-testid="footer-trust-badges"
              className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2.5 max-w-sm"
            >
              {TRUST.map((t) => (
                <li
                  key={t}
                  className="flex items-center gap-2 text-[13px] text-white/90"
                >
                  <Check
                    size={14}
                    strokeWidth={3}
                    className="text-[#1B93A4] shrink-0"
                  />
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="text-sm">
            <div className="text-white/65 uppercase tracking-[0.22em] text-xs font-bold">
              Kontakt
            </div>
            <div className="mt-4 space-y-2">
              <a
                href="tel:+420775601254"
                className="block text-white hover:text-[#1B93A4] transition-colors tabular-nums"
                data-testid="footer-phone"
              >
                +420 775 601 254
              </a>
              <a
                href="mailto:info@sanvioro.cz"
                className="block text-white hover:text-[#1B93A4] transition-colors"
                data-testid="footer-email"
              >
                info@sanvioro.cz
              </a>
              <div className="text-white/85">Brno, Česká republika</div>
            </div>
          </div>

          <div className="text-sm">
            <div className="text-white/65 uppercase tracking-[0.22em] text-xs font-bold">
              Navigace
            </div>
            <div className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2">
              <Link
                to="/#services"
                className="text-white/95 hover:text-[#1B93A4] transition-colors"
              >
                Služby
              </Link>
              <Link
                to="/#calc"
                className="text-white/95 hover:text-[#1B93A4] transition-colors"
              >
                Kalkulace
              </Link>
              <Link
                to="/#process"
                className="text-white/95 hover:text-[#1B93A4] transition-colors"
              >
                Proces
              </Link>
              <Link
                to="/#contact"
                className="text-white/95 hover:text-[#1B93A4] transition-colors"
              >
                Kontakt
              </Link>
              <Link
                to="/uklid-kancelari-brno"
                className="text-white/95 hover:text-[#1B93A4] transition-colors"
                data-testid="footer-link-uklid-kancelari"
              >
                Úklid kanceláří Brno
              </Link>
              <Link
                to="/uklid-bytovych-domu-brno"
                className="text-white/95 hover:text-[#1B93A4] transition-colors"
                data-testid="footer-link-uklid-bytovych-domu"
              >
                Úklid bytových domů Brno
              </Link>
              <Link
                to="/uklid-provozoven-brno"
                className="text-white/95 hover:text-[#1B93A4] transition-colors"
                data-testid="footer-link-uklid-provozoven"
              >
                Úklid provozoven Brno
              </Link>
              <Link
                to="/o-nas"
                className="text-white/95 hover:text-[#1B93A4] transition-colors"
                data-testid="footer-link-about"
              >
                O nás
              </Link>
              <Link
                to="/ochrana-osobnich-udaju"
                className="text-white/95 hover:text-[#1B93A4] transition-colors"
                data-testid="footer-link-privacy"
              >
                Ochrana údajů
              </Link>
              <Link
                to="/obchodni-podminky"
                className="col-span-2 text-white/95 hover:text-[#1B93A4] transition-colors"
                data-testid="footer-link-terms"
              >
                Obchodní podmínky
              </Link>
            </div>
          </div>
        </div>

        <div
          data-testid="footer-seo"
          className="mt-12 pt-6 border-t border-white/15 text-[13px] text-white/70 leading-relaxed"
        >
          <div className="text-white/55 uppercase tracking-[0.22em] text-[10px] font-bold mb-3">
            Klíčové služby
          </div>
          <div className="flex flex-wrap gap-x-3 gap-y-3.5">
            <Link to="/uklid-kancelari-brno" className="hover:text-[#1B93A4] transition-colors">Úklid kanceláří Brno</Link>
            <span className="text-white/25">·</span>
            <Link to="/uklid-kancelari-brno" className="hover:text-[#1B93A4] transition-colors">Pravidelný úklid kanceláří Brno</Link>
            <span className="text-white/25">·</span>
            <Link to="/uklid-kancelari-brno" className="hover:text-[#1B93A4] transition-colors">Úklid kancelářských budov Brno</Link>
            <span className="text-white/25">·</span>
            <Link to="/uklid-kancelari-brno" className="hover:text-[#1B93A4] transition-colors">Úklid administrativních budov Brno</Link>
            <span className="text-white/25">·</span>
            <Link to="/uklid-provozoven-brno" className="hover:text-[#1B93A4] transition-colors">Úklid firem Brno</Link>
            <span className="text-white/25">·</span>
            <Link to="/uklid-provozoven-brno" className="hover:text-[#1B93A4] transition-colors">Úklid firemních prostor Brno</Link>
            <span className="text-white/25">·</span>
            <Link to="/uklid-provozoven-brno" className="hover:text-[#1B93A4] transition-colors">Komerční úklid Brno</Link>
            <span className="text-white/25">·</span>
            <Link to="/uklid-provozoven-brno" className="hover:text-[#1B93A4] transition-colors">Facility úklid Brno</Link>
            <span className="text-white/25">·</span>
            <Link to="/uklid-provozoven-brno" className="hover:text-[#1B93A4] transition-colors">Úklid provozoven Brno</Link>
            <span className="text-white/25">·</span>
            <Link to="/uklid-bytovych-domu-brno" className="hover:text-[#1B93A4] transition-colors">Úklid společných prostor Brno</Link>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-3 text-xs text-white/65">
          <div>© {year} SANVIORO. Všechna práva vyhrazena.</div>
          <div className="tabular-nums">[ Made in Brno · CZ ]</div>
        </div>
        <div
          data-testid="legal-entity"
          className="mt-4 text-[12px] text-white/65 tracking-wide leading-relaxed"
        >
          Sanvioro s.r.o., IČO 29637066 · Příkop 843/4, Zábrdovice, 602 00 Brno
        </div>
      </div>
    </footer>
  );
};

export default Footer;
